import { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
    Card, Stack, Container, Typography, Box, Link, Divider, CircularProgress,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import Page from 'src/components/Page';
import syndicationApi from 'src/utils/syndicationApi';

const RootStyle = styled(Page)(({ theme }) => ({
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'flex-start',
    background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
    padding: theme.spacing(6, 0),
}));

const ContentCard = styled(Card)(({ theme }) => ({
    maxWidth: 800,
    width: '100%',
    padding: theme.spacing(5),
    borderRadius: 16,
    boxShadow: '0 8px 40px rgba(0,0,0,0.12)',
}));

export default function InvestorPrivacy() {
    const [loading, setLoading] = useState(true);
    const [legalData, setLegalData] = useState(null);

    useEffect(() => {
        syndicationApi.get('legal/')
            .then((res) => setLegalData(res.data?.data))
            .catch(() => setLegalData(null))
            .finally(() => setLoading(false));
    }, []);

    return (
        <RootStyle title="Privacy Policy | Gateway X Syndication">
            <Container maxWidth="md" sx={{ display: 'flex', justifyContent: 'center' }}>
                <ContentCard>
                    <Stack spacing={3}>
                        <Box sx={{ textAlign: 'center' }}>
                            <Typography variant="h4" gutterBottom>Privacy Policy</Typography>
                            {legalData?.privacy_policy_version && (
                                <Typography variant="caption" color="text.secondary">
                                    Version {legalData.privacy_policy_version}
                                </Typography>
                            )}
                        </Box>

                        <Divider />

                        {loading ? (
                            <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                                <CircularProgress />
                            </Box>
                        ) : legalData?.privacy_policy_text ? (
                            <Box
                                sx={{ '& p': { mb: 1.5 }, '& h3': { mt: 2 } }}
                                dangerouslySetInnerHTML={{ __html: legalData.privacy_policy_text }}
                            />
                        ) : (
                            <Typography color="text.secondary" sx={{ textAlign: 'center', py: 4 }}>
                                Privacy Policy content is not yet available.
                            </Typography>
                        )}

                        <Divider />
                        <Stack direction="row" spacing={2} justifyContent="center">
                            <Link component={RouterLink} to="/investor/terms" variant="body2">
                                Terms of Service
                            </Link>
                            <Link component={RouterLink} to="/investor/login" variant="body2">
                                Back to Login
                            </Link>
                        </Stack>
                    </Stack>
                </ContentCard>
            </Container>
        </RootStyle>
    );
}
